/* eslint-disable no-undef */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { driver } from 'driver.js';
import PropTypes from 'prop-types';

class DriverLibrary extends Component {
  constructor(props) {
    super(props);
    this.driverObj = null;
  }

  componentDidMount() {
    this.driverObj = driver({
      showProgress: true,
      animate: true,
      keyboardControl: true,
      overlayClickNext: true,
      nextBtnText: 'Next',
      prevBtnText: 'Previous',
      doneBtnText: 'Finish',
    });

    this.setSteps();
    this.waitForElement('#challenge-snapshot').then(() => {
      this.driverObj.drive();
    });
  }

  waitForElement = (selector, timeout = 4000) => {
    return new Promise((resolve, reject) => {
      const interval = 100;
      let waited = 0;

      const checker = setInterval(() => {
        if (document.querySelector(selector)) {
          clearInterval(checker);
          resolve();
        } else {
          waited += interval;
          if (waited >= timeout) {
            clearInterval(checker);
            // reject(`Timeout waiting for ${selector}`);
          }
        }
      }, interval);
    });
  };

  setSteps = () => {
    this.driverObj.setSteps([
      {
        element: '#challenge-snapshot',
        popover: {
          title: 'Snapshot',
          description: 'Get a quick overview of ongoing challenges, participation rates, and overall progress.',
          position: 'bottom',
        },
        onNextClick: async () => {
          if (this.props.activeTabId !== 1) {
            this.props.setTab(1); // Completed tab
            await this.waitForElement('#completed-section');
            this.driverObj.drive();
          }
        },
      },
      {
        element: '#year-dropdown',
        popover: {
          title: 'Year-filter',
          description: 'Easily switch between years to view challenge data and trends over time.',
          position: 'bottom',
        },
        onNextClick: async () => {
          if (this.props.activeTabId !== 1) {
            this.props.setTab(1); // Completed tab
            await this.waitForElement('#completed-section');
            this.driverObj.drive();
          }
        },
      },

      {
        element: '#challenge-completed',
        popover: {
          title: 'Completed',
          description: 'View all the challenges that have been completed so far.',
          position: 'bottom',
        },
        onNextClick: async () => {
          if (this.props.activeTabId !== 2) {
            this.props.setTab(2); // Library tab
            await this.waitForElement('#activitysubtab');
            this.driverObj.drive();
          }
        },
        
      },
      {
        element: '#challenge-library',
        popover: {
          title: 'Library',
          description: 'Browse a curated collection of ready-to-launch challenges.',
          position: 'bottom',
        },
        onNextClick: async () => {
          if (this.props.activeTabId !== 2) {
            this.props.setTab(2); // Library tab
            await this.waitForElement('#activitysubtab');
            this.driverObj.drive();
          }
        },
        
      },
      {
        element: '#activitysubtab',
        popover: {
          title: 'Activity Tab',
          description: 'View physical activity-based challenges.',
          position: 'bottom',
        },
        onNextClick: async () => {
          if (this.props.activeTabId !== 3) {
            this.props.setTab(3); // Wellness tab
            await this.waitForElement('#wellnesssubtab');
            this.driverObj.drive();
          }
        },
        onPreviousClick: async () => {
          if (this.props.activeTabId !== 1) {
            this.props.setTab(1); // Completed tab
            await this.waitForElement('#completed-section');
            this.driverObj.drive();
          }
        },
      },
      {
        element: '#wellnesssubtab',
        popover: {
          title: 'Wellness Tab',
          description: 'Explore wellness & behavioral challenges.',
          position: 'bottom',
        },
        onPreviousClick: async () => {
          if (this.props.activeTabId !== 2) {
            this.props.setTab(2); // Library tab
            await this.waitForElement('#activitysubtab');
            this.driverObj.drive();
          }
        },
      },
    ]);
  };

  render() {
    return null;
  }
}

DriverLibrary.propTypes = {
  activeTabId: PropTypes.number.isRequired,
  setTab: PropTypes.func.isRequired,
};

export default DriverLibrary;

